import { useEffect, useState } from "react";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { api } from "@/lib/api";

const gbp = (v) => `£${Number(v || 0).toLocaleString("en-GB", { maximumFractionDigits: 0 })}`;

export const SpendChart = () => {
  const [months, setMonths] = useState(12);
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/trustee/fleet-spend", { params: { months } }).then((r) => setData(r.data.map((m) => ({
      ...m, label: new Date(Number(m.month.slice(0, 4)), Number(m.month.slice(5)) - 1, 1).toLocaleDateString("en-GB", { month: "short", year: months > 12 ? "2-digit" : undefined }),
    }))));
  }, [months]);
  const total = data?.reduce((a, m) => a + m.total, 0) || 0;
  return (
    <section data-testid="spend-chart" className="rounded-2xl border bg-card p-5">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 className="font-bold">Fleet spending by month</h3>
          <p data-testid="spend-total" className="text-xs text-muted-foreground">{gbp(total)} over the last {months} months</p>
        </div>
        <div className="flex gap-1.5">
          {[6, 12, 24].map((m) => (
            <button key={m} onClick={() => setMonths(m)} data-testid={`spend-range-${m}`}
              className={`rounded-full border-2 px-3 py-1 text-xs font-semibold ${months === m ? "border-primary bg-primary text-primary-foreground" : "text-muted-foreground"}`}>{m} months</button>
          ))}
        </div>
      </div>
      <div className="h-64">
        {data && (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data}>
              <CartesianGrid strokeDasharray="3 3" stroke="#9CA3AF" strokeOpacity={0.2} vertical={false} />
              <XAxis dataKey="label" stroke="#9CA3AF" fontSize={11} />
              <YAxis stroke="#9CA3AF" fontSize={11} tickFormatter={gbp} width={60} />
              <Tooltip cursor={{ fill: "hsl(var(--secondary))", opacity: 0.4 }} formatter={(v) => gbp(v)} contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", color: "hsl(var(--foreground))" }} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Bar dataKey="repair" name="Repairs, brakes & tyres" stackId="a" fill="#DB0000" />
              <Bar dataKey="service" name="Service & other" stackId="a" fill="#0EA5E9" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </section>
  );
};
